import { useMediaQuery } from '@mui/material';
/**
 * Returns `true` if users pointing device supports hover.
 * Used by `GlobalApp` to control menu and pinned bar visibility.
 */
export function useHoverSupported() {
    return useMediaQuery('screen and (hover: hover) and (pointer: fine)', { noSsr: true });
}
